import React, { useEffect, useContext, useState } from "react";
import CelebSidebar from "../sidebar/index";
import Navbar from "../landingpage/sections/Navbar/index"
import { doctordashboardprofile01 } from "../imagepath";
import Footer from "../home/footer";
import { Link, Navigate } from "react-router-dom";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { AuthContext } from "../../context/AuthContext";
import { getCelebIncomingRequests } from "../../services/celebShoutouts";
import { getCelebStatistics } from "../../services/celebShoutouts";

const CelebDashboard = (props) => {
  const { user, isAuthenticated, isLoading } = useContext(AuthContext);
  const [incomingRequests, setIncomingRequests] = useState([]);
  const [urgentRequest, setUrgentRequest] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [statistics, setStatistics] = useState(null);
  const [recentShoutouts, setRecentShoutouts] = useState([]);
  const [statsLoading, setStatsLoading] = useState(true);

  useEffect(() => {
    if (isAuthenticated && user?.userType === 'celeb') {
      fetchIncomingRequests();
      fetchStatistics();
    }
  }, [isAuthenticated, user]);

  const fetchIncomingRequests = async () => {
    try {
      setLoading(true);
      const response = await getCelebIncomingRequests();
      const requests = response.data?.requests || [];


      const filteredRequests = requests.filter(request =>
        request.status === 'pending' || request.status === 'accepted'
      );

      setIncomingRequests(filteredRequests);

      if (filteredRequests.length > 0) {
        const nonApprovedRequests = filteredRequests.filter(request =>
          request.status !== 'approved'
        );

        if (nonApprovedRequests.length > 0) {
          const sortedByUrgency = [...nonApprovedRequests].sort((a, b) => {
            return new Date(a.deliveryDate) - new Date(b.deliveryDate);
          });
          setUrgentRequest(sortedByUrgency[0]);
        } else {
          setUrgentRequest(null);
        }
      } else {
        setUrgentRequest(null);
      }
    } catch (err) {
      setError(err.message || "Failed to fetch incoming requests");
      console.error("Error fetching incoming requests:", err);
    } finally {
      setLoading(false);
    }
  };

  const fetchStatistics = async () => {
    try {
      setStatsLoading(true);
      const response = await getCelebStatistics();
      if (response.success) {
        setStatistics(response.data?.statistics || {});
        setRecentShoutouts(response.data?.recentShoutouts || []);
      }
    } catch (err) {
      console.error("Error fetching statistics:", err);
    } finally {
      setStatsLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const options = {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(amount);
  };

  const getStatusBadgeClass = (status) => {
    switch (status) {
      case 'completed': return 'badge bg-success';
      case 'accepted': return 'badge bg-primary';
      case 'pending': return 'badge bg-warning';
      case 'declined': return 'badge bg-danger';
      default: return 'badge bg-secondary';
    }
  };

  if (isLoading) {
    return <div className="loading-screen">Loading...</div>;
  }

  if (!isAuthenticated || user?.userType !== 'celeb') {
    return <Navigate to="/" replace />;
  }

  return (
    <div>
      <Navbar {...props} />
      {/* Breadcrumb */}
      <div className="breadcrumb-bar"
        style={{
          backgroundColor: 'var(--breadcrumb-bg)',
          transition: 'background-color 0.3s ease'
        }}
      >
        <div className="container">
          <div className="row align-items-center inner-banner">
            <div className="col-md-12 col-12 text-center">
              <nav aria-label="breadcrumb" className="page-breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="/">
                      <i className="isax isax-home-15" />
                    </a>
                  </li>
                  <li className="breadcrumb-item" aria-current="page">
                    Celebrity
                  </li>
                  <li className="breadcrumb-item active">Dashboard</li>
                </ol>
                <h2 className="breadcrumb-title">Welcome, {user?.fullName || 'Celebrity'}</h2>
              </nav>
            </div>
          </div>
        </div>
        <div className="breadcrumb-bg">
          <ImageWithBasePath
            src="assets/img/bg/breadcrumb-bg-01.png"
            alt="img"
            className="breadcrumb-bg-01"
          />
          <ImageWithBasePath
            src="assets/img/bg/breadcrumb-bg-02.png"
            alt="img"
            className="breadcrumb-bg-02"
          />
          <ImageWithBasePath
            src="assets/img/bg/breadcrumb-icon.png"
            alt="img"
            className="breadcrumb-bg-03"
          />
          <ImageWithBasePath
            src="assets/img/bg/breadcrumb-icon.png"
            alt="img"
            className="breadcrumb-bg-04"
          />
        </div>
      </div>
      {/* /Breadcrumb */}

      {/* Page Content */}
      <div className="content">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-xl-3 theiaStickySidebar">
              <div className="stickybar">
                <CelebSidebar user={user} />
              </div>
            </div>
            <div className="col-lg-8 col-xl-9">
              <div className="row">
                {/* Statistics Dashboard Boxes */}
                <div className="col-xl-4 d-flex">
                  <div className="dashboard-box-col w-100">
                    <div className="dashboard-widget-box">
                      <div className="dashboard-content-info">
                        <h6>Total Earnings</h6>
                        <h4>{statsLoading ? "--" : formatCurrency(statistics?.completedEarnings || 0)}</h4>
                        <span className="text-success">
                          <i className="fa-solid fa-arrow-up" />
                          All Time Revenue
                        </span>
                      </div>
                      <div className="dashboard-widget-icon">
                        <span className="dash-icon-box">
                          <i className="fa-solid fa-dollar-sign" />
                        </span>
                      </div>
                    </div>
                    <div className="dashboard-widget-box">
                      <div className="dashboard-content-info">
                        <h6>Completed Shoutouts</h6>
                        <h4>{statsLoading ? "--" : statistics?.completedShoutouts || 0}</h4>
                        <span className="text-primary">
                          <i className="fa-solid fa-check-circle" />
                          Successful Deliveries
                        </span>
                      </div>
                      <div className="dashboard-widget-icon">
                        <span className="dash-icon-box">
                          <i className="fa-solid fa-check-circle" />
                        </span>
                      </div>
                    </div>
                    <div className="dashboard-widget-box">
                      <div className="dashboard-content-info">
                        <h6>Pending Requests</h6>
                        <h4>{statsLoading ? "--" : statistics?.pendingShoutouts || 0}</h4>
                        <span className="text-warning">
                          <i className="fa-solid fa-clock" />
                          Needs Attention
                        </span>
                      </div>
                      <div className="dashboard-widget-icon">
                        <span className="dash-icon-box">
                          <i className="fa-solid fa-clock" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-xl-8 d-flex">
                  <div className="dashboard-card w-100">
                    <div className="dashboard-card-head">
                      <div className="header-title">
                        <h5>Incoming Requests</h5>
                      </div>
                      <div className="dropdown header-dropdown">
                        All Requests
                      </div>
                    </div>
                    <div className="dashboard-card-body">
                      {loading ? (
                        <div className="text-center py-4">Loading requests...</div>
                      ) : error ? (
                        <div className="text-center text-danger py-4">{error}</div>
                      ) : incomingRequests.length === 0 ? (
                        <div className="text-center py-4">No incoming requests found</div>
                      ) : (
                        <div className="table-responsive">
                          <table className="table dashboard-table">
                            <tbody>
                              {incomingRequests.slice(0, 5).map((request) => (
                                <tr key={request._id}>
                                  <td>
                                    <div className="patient-info-profile">
                                      <Link to="#" className="table-avatar">
                                        <img
                                          src={request.user?.profilepicture || doctordashboardprofile01}
                                          alt="Img"
                                          onError={(e) => {
                                            e.target.src = doctordashboardprofile01;
                                          }}
                                        />
                                      </Link>
                                      <div className="patient-name-info">
                                        <span>#{request._id?.slice(-6)}</span>
                                        <h5>
                                          <Link to="#">
                                            {request.user?.fullName || 'Unknown User'}
                                          </Link>
                                        </h5>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="appointment-date-created">
                                      <h6>{formatDate(request.deliveryDate)}</h6>
                                      <span className="badge table-badge">
                                        {request.recipientName}
                                      </span>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="appointment-detail-btn">
                                      <Link
                                        to="/order-start"
                                        className="start-link"
                                        state={{ order: request }}
                                      >
                                        <i className="fa-regular fa-eye me-1" />
                                        View
                                      </Link>
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-xl-7 d-flex">
                  <div className="dashboard-main-col w-100">
                    {urgentRequest ? (
                      <div className="upcoming-appointment-card">
                        <div className="title-card">
                          <h5>Most Urgent Order</h5>
                        </div>
                        <div className="upcoming-patient-info">
                          <div className="info-details">
                            <span className="img-avatar">
                              <img
                                src={urgentRequest.user?.profilepicture || doctordashboardprofile01}
                                alt={urgentRequest.user?.fullName}
                                onError={(e) => {
                                  e.target.src = doctordashboardprofile01;
                                }}
                              />
                            </span>
                            <div className="name-info">
                              <span>#{urgentRequest._id?.slice(-6)}</span>
                              <h6>{urgentRequest.user?.fullName || 'Unknown User'}</h6>
                            </div>
                          </div>
                          <div className="date-details">
                            <span><h6>Recipient</h6><h4>{urgentRequest.recipientName}</h4></span>
                            <h6>{formatDate(urgentRequest.deliveryDate)}</h6>
                          </div>
                        </div>
                        <div className="appointment-card-footer">
                          <h5>
                            <i className="fa-solid fa-video" />
                            Video shoutout
                          </h5>
                          <div className="btn-appointments">
                            <Link to="/order-start" className="btn" state={{ order: urgentRequest }}>
                              Make video
                            </Link>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="upcoming-appointment-card">
                        <div className="title-card">
                          <h5>Most Urgent Order</h5>
                        </div>
                        <div className="upcoming-patient-info">
                          <div className="info-details">
                            <span className="img-avatar">
                              <img src={doctordashboardprofile01} alt="No urgent requests" />
                            </span>
                            <div className="name-info">
                              <span>No urgent requests</span>
                              <h6>All caught up!</h6>
                            </div>
                          </div>
                          <div className="date-details">
                            <span>Status</span>
                            <h6>No pending orders</h6>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Additional Statistics Cards */}
                    <div className="row mt-4">
                      <div className="col-md-6">
                        <div className="dashboard-widget-box">
                          <div className="dashboard-content-info">
                            <h6>Total Shoutouts</h6>
                            <h4>{statsLoading ? "--" : statistics?.totalShoutouts || 0}</h4>
                            <span className="text-info">
                              <i className="fa-solid fa-microphone" />
                              All Requests
                            </span>
                          </div>
                          <div className="dashboard-widget-icon">
                            <span className="dash-icon-box">
                              <i className="fa-solid fa-microphone" />
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="dashboard-widget-box">
                          <div className="dashboard-content-info">
                            <h6>Earned + Pending</h6>
                            <h4>{statsLoading ? "--" : formatCurrency(statistics?.totalEarnings || 0)}</h4>
                            <span className="text-success">
                              <i className="fa-solid fa-wallet" />
                              Expected.
                            </span>
                          </div>
                          <div className="dashboard-widget-icon">
                            <span className="dash-icon-box">
                              <i className="fa-solid fa-wallet" />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
                <div className="col-xl-12 d-flex">
                  <div className="dashboard-card w-100 mt-4">
                    <div className="dashboard-card-head">
                      <div className="header-title">
                        <h5>Recent Shoutouts</h5>
                      </div>
                    </div>
                    <div className="dashboard-card-body">
                      {statsLoading ? (
                        <div className="text-center py-4">Loading recent shoutouts...</div>
                      ) : recentShoutouts.length === 0 ? (
                        <div className="text-center py-4">No recent shoutouts found</div>
                      ) : (
                        <div className="table-responsive">
                          <table className="table dashboard-table">
                            <thead>
                              <tr>
                                <th>Customer</th>
                                <th>Recipient</th>
                                <th>Delivery Date</th>
                                <th>Status</th>
                                <th>Amount</th>
                              </tr>
                            </thead>
                            <tbody>
                              {recentShoutouts.slice(0, 5).map((shoutout) => (
                                <tr key={shoutout._id}>
                                  <td>
                                    <div className="patient-info-profile">
                                      <Link to="#" className="table-avatar">
                                        <img
                                          src={shoutout.userId?.profilepicture || doctordashboardprofile01}
                                          alt={shoutout.userId?.fullName}
                                          onError={(e) => {
                                            e.target.src = doctordashboardprofile01;
                                          }}
                                        />
                                      </Link>
                                      <div className="patient-name-info">
                                        <h6>{shoutout.userId?.fullName || 'Unknown User'}</h6>
                                        <span>#{shoutout._id?.slice(-6)}</span>
                                      </div>
                                    </div>
                                  </td>
                                  <td>{shoutout.recipientName}</td>
                                  <td>{new Date(shoutout.deliveryDate).toLocaleDateString()}</td>
                                  <td>
                                    <span className={getStatusBadgeClass(shoutout.status)}>
                                      {shoutout.status}
                                    </span>
                                  </td>
                                  <td>{formatCurrency(shoutout.amount)}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                  </div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Content */}
      <Footer {...props} />
    </div>
  );
};

export default CelebDashboard;